import { useAccountContext } from '@gonfalon/app-context/useAccountContext';
import { isReader } from '@gonfalon/members/isReader';
import { toCreateFlag, toFlags } from '@gonfalon/navigator/navigators';
import { Restrict } from '@gonfalon/permissions/restrict';
import { Link, LinkButton } from '@launchpad-ui/components';

import { Jumbo } from '#components/Jumbo';

type FlagNotFoundProps = {
  projKey: string;
  envKey: string | undefined;
};

export function FlagNotFound({ projKey, envKey }: FlagNotFoundProps) {
  const { profile } = useAccountContext();
  const isReader_ = isReader(profile);
  const action = (
    <Restrict willHide isRestricted={isReader_}>
      <>
        {envKey && (
          <>
            <LinkButton variant="primary" href={toCreateFlag({ projectKey: projKey, environmentKey: envKey })}>
              Create flag
            </LinkButton>{' '}
            or go{' '}
          </>
        )}
        <Link href={toFlags({ projectKey: projKey })}>Back to the dashboard</Link>
      </>
    </Restrict>
  );

  return (
    <Jumbo title="Flag not found" lead="Sorry, we can’t find the flag you’re looking for." actions={action} isError />
  );
}
